export default __webpack_public_path__ + "static/media/IP-Sales.16cb2e39.svg";